export const acceptedFormat = 'image/jpeg, image/png'
export const baseSupportImage = './images/platform/default-user-icon.svg'
